<div style="position:sticky; top:-1px; z-index:100;">
  <app-dp-bottom-sheet-closer (closeClicked)="closedialog()">
  </app-dp-bottom-sheet-closer>
</div>

<mat-dialog-content class="modal-content" style="overflow:hidden">
  @if(!isLoading){
  @if(tempData?.length>0){
  <input type="text" [formControl]="searchReq" class="dp-input-control searchInput"
    placeholder="Search in displayed result" />}
  @if(datatable.length>0) {
  <div class="dp-table-scroll tableBoxMob" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="1"
    [infiniteScrollThrottle]="1000" (scrolled)="loadMoreData(false)" style="height: auto;">
    @for( lists of datatable; track lists){
    <ul class="eachdataList" (click)="onClickRowData(lists)">
      <li class="data">
        Sl.No <span class="serial-no" #tooltip="matTooltip" matTooltipPosition="below"
          (click)="onMKClick($event,tooltip)" matTooltip="Sl no. copied" [cdkCopyToClipboard]="lists.mk">{{
          checkNull(lists.mk) }}</span>
      </li>
      <li class="data">
        Status<span>{{ checkNull(lists.rs) }}</span>
      </li>
      <li class="data">
        District <span>{{ checkNull(lists.dn) }}</span>
      </li>
      <li class="data">
        Name <span>{{ checkNull(lists.fullName) }}</span>
      </li>
      <li class="data">
        Guardian <span>{{ checkNull(lists.guardianName) }}</span>
      </li>
      <li class="data">
        Initiation date <span>{{ checkNull(lists.md) }}</span>
      </li>
      <li class="data">
        Ritwik <span>{{ checkNull(lists.rn) }}</span>
      </li>
      <li class="data">
        Address <span>{{ checkNull(lists.add) }}</span>
      </li>
    </ul>
    }
  </div>

  } @else {

  <div class="noData mt-5 d-flex justify-content-center flex-column align-items-center">
    <div class="placeholderTable"></div>
    <p>No data found!</p>
  </div>
  }
  }
</mat-dialog-content>
<app-loader [isLoading]="isLoading"></app-loader>